import { setContext, getContext } from "svelte";
export const setAppContext = (appContext) => setContext("appContext", appContext);
export const getAppContext = () => getContext("appContext");
